import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const ContentContext = createContext(null);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(null);
  const [gallery, setGallery] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [awards, setAwards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    Promise.all([
      api.get("/content"),
      api.get("/gallery"),
      api.get("/testimonials"),
      api.get("/awards"),
    ])
      .then(([c, g, t, a]) => {
        if (!active) return;
        setContent(c.data || {});
        setGallery(g.data || []);
        setTestimonials(t.data || []);
        setAwards(a.data || []);
      })
      .catch(() => { if (active) setContent({}); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  return (
    <ContentContext.Provider value={{ content, gallery, testimonials, awards, loading }}>
      {children}
    </ContentContext.Provider>
  );
}

export function useContent() {
  const ctx = useContext(ContentContext);
  if (!ctx) throw new Error("useContent must be used inside ContentProvider");
  return ctx;
}
